// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5e23835e","703":"8abf8a8b"}[chunkId] + ".chunk.js";
};